// container/calendar-module.ts
import { Container, ContainerItem } from 'common/container/Container'
import { getAppContainer } from './app'
import { moduleURLs } from 'config/api'
import {
  CALENDAR_MODULE,
  CalendarProps,
  EVENT_API_KEY,
  EVENT_SERVICE_KEY,
  APPOINTMENT_API_KEY,
  APPOINTMENT_SERVICE_KEY,
  NOTE_API_KEY,
  NOTE_SERVICE_KEY,
  TASK_API_KEY,
  TASK_SERVICE_KEY,
  EXTERN_APPOINTMENT_SERVICE_KEY,
  EXTERN_APPOINTMENT_API_KEY,
  // Importar los nuevos símbolos
  EXTERN_APPOINTMENT_SCHEDULE_API_KEY,
  EXTERN_APPOINTMENT_SCHEDULE_SERVICE_KEY,
} from 'modules/calendar/container'
import { EventService } from 'modules/calendar/services/EventService'
import { EventApi } from 'modules/calendar/api/EventApi'
import { AppointmentApi } from 'modules/calendar/api/AppointmentApi'
import { NoteApi } from 'modules/calendar/api/NoteApi'
import { TaskApi } from 'modules/calendar/api/TaskApi'
import { ExternAppointmentService } from 'modules/calendar/services/ExternAppointmentService'
import { ExternAppointmentApi } from 'modules/calendar/api/ExternAppointmentApi'
// Importar los nuevos servicios y APIs
import { ExternAppointmentScheduleService } from 'modules/calendar/services/ExternAppointmentScheduleService'
import { ExternAppointmentScheduleApi } from 'modules/calendar/api/ExternAppointmentScheduleApi'

let container: Container

function init(p: CalendarProps) {
  const items = new Map<symbol, ContainerItem>()

  items.set(EVENT_API_KEY, new ContainerItem({ instance: new EventApi() }))

  items.set(
    EVENT_SERVICE_KEY,
    new ContainerItem({ instance: new EventService({ apiKey: EVENT_API_KEY }) })
  )

  items.set(APPOINTMENT_API_KEY, new ContainerItem({ instance: new AppointmentApi() }))

  items.set(
    APPOINTMENT_SERVICE_KEY,
    new ContainerItem({ instance: new EventService({ apiKey: APPOINTMENT_API_KEY }) })
  )

  items.set(NOTE_API_KEY, new ContainerItem({ instance: new NoteApi() }))

  items.set(
    NOTE_SERVICE_KEY,
    new ContainerItem({ instance: new EventService({ apiKey: NOTE_API_KEY }) })
  )

  items.set(TASK_API_KEY, new ContainerItem({ instance: new TaskApi() }))

  items.set(
    TASK_SERVICE_KEY,
    new ContainerItem({ instance: new EventService({ apiKey: TASK_API_KEY }) })
  )

  items.set(EXTERN_APPOINTMENT_API_KEY, new ContainerItem({ instance: new ExternAppointmentApi() }))

  items.set(
    EXTERN_APPOINTMENT_SERVICE_KEY,
    new ContainerItem({
      instance: new ExternAppointmentService({ apiKey: EXTERN_APPOINTMENT_API_KEY }),
    })
  )

  // Añadir los nuevos servicios para ExternAppointmentSchedule
  items.set(
    EXTERN_APPOINTMENT_SCHEDULE_API_KEY,
    new ContainerItem({
      instance: new ExternAppointmentScheduleApi(),
    })
  )

  items.set(
    EXTERN_APPOINTMENT_SCHEDULE_SERVICE_KEY,
    new ContainerItem({
      instance: new ExternAppointmentScheduleService({
        apiKey: EXTERN_APPOINTMENT_SCHEDULE_API_KEY,
      }),
    })
  )

  container = new Container(items, p.parentContainer, p.config)
}

export function getCalendarContainer(): Container {
  if (!container) {
    init({
      parentContainer: getAppContainer(),
      config: {
        moduleFullUrl: moduleURLs[CALENDAR_MODULE],
      },
    })
  }

  return container
}
